const nonnhsfees = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "Non NHS Fees",
      },
      {
        type: "tabs",
        size: "12",
        style: "",
        class: "px-4 pt-4",
        children: [
          {
            title: "Settings",
            service: "category",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: false,
              deleteButton: false,
              updateSuccessTitle: "Category Updated!",
              updateSuccessMessage: "Category Updated Successfully!",
              updateErrorTitle: "Category Updation Failed!",
              updateErrorMessage: "Please try again!",
            },
            children: [
              {
                type: "descriptionTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  type: "list",
                  size: "4",
                  style: "",
                  class: "p-2",
                  empty: true,
                  children: [],
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  form: {
                    info_box: {
                      type: "checkbox",
                      label: "",
                      hideLabel: false,
                      placeholder: "Info Box",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    info_title: {
                      type: "text",
                      label: "Info Title",
                      placeholder: "Enter Info Title",
                      displayOn: "info_box",
                      displayOnValue: "true",
                      required: true,
                      info: true,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    info_description: {
                      type: "ckeditor",
                      label: "Info Description",
                      placeholder: "Enter Description",
                      displayOn: "info_box",
                      displayOnValue: "true",
                      required: true,
                      info: false,
                      character_count: 2000,
                      disabled: false,
                      class: "editor-toolbar-bg-change",
                      size: "12",
                      style: "",
                    },
                    hr1: {
                      type: "hr",
                      size: "12",
                    },
                    page_title: {
                      type: "text",
                      label: "Page Title",
                      placeholder: "Enter Title",
                      required: true,
                      info: true,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    description: {
                      type: "ckeditor",
                      label: "Page Description",
                      placeholder: "Enter Description",
                      required: true,
                      info: false,
                      character_count: 2000,
                      disabled: false,
                      class: "editor-toolbar-bg-change",
                      size: "12",
                      style: "",
                    },
                    // hr3: {
                    //   type: "hr",
                    //   size: "12",
                    // },
                  },
                  children: [],
                },
              },
            ],
          },
          {
            title: "Groups",
            service: "categoryGroups",
            type: "",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: true,
              activeToggle: true,
              deleteButton: true,
              addNewSuccessTitle: "Group Added!",
              addNewSuccessMessage: "Group Added Successfully!",
              addNewErrorTitle: "Group Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Group Deleted!",
              deleteSuccessMessage: "Group Deleted Successfully!",
              deleteErrorTitle: "Group Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Group Activated!",
              activeSuccessMessage: "Group Activated Successfully!",
              activeErrorTitle: "Group Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Group Updated!",
              updateSuccessMessage: "Group Updated Successfully!",
              updateErrorTitle: "Group Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New Group",
                variant: "add",
                form: {
                  title: {
                    type: "text",
                    label: "Group Name",
                    placeholder: "Enter Group Name",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProps: {
                  active: true,
                },
              },
            },
            children: [
              {
                type: "groupsTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Group",
                  type: "groupList",
                  info: true,
                  size: "4",
                  style: "",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                },
                form: {
                  title: "Tab Two",
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  submit_url: "/api/pages/$currentPageId",
                  form: {
                    title: {
                      type: "text",
                      label: "Group Name",
                      placeholder: "Enter Group Name",
                      required: true,
                      info: true,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    subgroups: {
                      type: "subgroup",
                      label: "Sub-groups",
                      placeholder: "Enter Subgroup",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    // "address": {
                    //     "type": 'text',
                    //     "label": 'Address',
                    //     "placeholder": 'Enter Address',
                    //     "required": true,
                    //     "info": true,
                    //     "character_count": 250,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "12",
                    //     "style": ""
                    // },
                    // "date": {
                    //     "type": 'date',
                    //     "label": 'Date',
                    //     "placeholder": 'Enter Date',
                    //     "required": true,
                    //     "info": true,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "12",
                    //     "style": ""
                    // },
                  },
                  children: [],
                },
              },
            ],
          },
          {
            title: "Fee List",
            service: "pages",
            type: "",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: true,
              activeToggle: true,
              deleteButton: true,
              addNewSuccessTitle: "Topic Added!",
              addNewSuccessMessage: "Topic Added Successfully!",
              addNewErrorTitle: "Topic Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Topic Deleted!",
              deleteSuccessMessage: "Topic Deleted Successfully!",
              deleteErrorTitle: "Topic Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Topic Activated!",
              activeSuccessMessage: "Topic Activated Successfully!",
              activeErrorTitle: "Topic Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Topic Updated!",
              updateSuccessMessage: "Topic Updated Successfully!",
              updateErrorTitle: "Topic Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New Item",
                variant: "add",
                submit_url: "/api/categories/$currentCategoryId/pages",
                form: {
                  group: {
                    type: "groupSelect",
                    label: "Group",
                    placeholder: "Select Group",
                    load_url: "",
                    required: false,
                    info: false,
                    character_count: 0,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                  title: {
                    type: "text",
                    label: "Item Name",
                    placeholder: "Enter Item Name",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                  price: {
                    type: "text",
                    label: "price",
                    placeholder: "Enter Price",
                    required: true,
                    info: true,
                    character_count: 250,
                    displayOn: "layout",
                    displayOnValue: "double",
                    disabled: false,
                    class: "",
                    size: "6",
                    style: "",
                  },
                  description: {
                    type: "text",
                    label: "price1",
                    placeholder: "Enter Price",
                    required: true,
                    info: true,
                    character_count: 250,
                    displayOn: "layout",
                    displayOnValue: "double",
                    disabled: false,
                    class: "",
                    size: "6",
                    style: "",
                  },
                  layout: {
                    type: "radioObjectwithImg",
                    label: "Layout",
                    placeholder: "Select Layout",
                    required: false,
                    info: true,
                    character_count: 0,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                    options: [
                      {
                        name: "single",
                        value: "single",
                        displayName: "Single Column",
                        icon: "singlelayout.svg",
                      },
                      {
                        name: "double",
                        value: "double",
                        displayName: "Double Column",
                        icon: "doublelayout.svg",
                      },
                    ],
                  },
                },
                additionalProps: {
                  group: "",
                  subgroup: "",
                  locations: "",
                  availability: {
                    locations: [],
                  },
                },
              },
            },
            children: [
              {
                type: "membersTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Item",
                  // "type": "list",
                  type: "list",
                  variant: "filtered",
                  filter: "groups",
                  filterOn: "group",
                  info: true,
                  size: "4",
                  style: "",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                  withoutSubGroups: true,
                },
                form: {
                  title: "Tab Two",
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  submit_url: "/api/pages/$currentPageId",
                  rules: {
                    condition: {
                      key: "enable_webform",
                      value: false,
                    },
                    actions: [
                      {
                        actionType: "CHANGE_VALUE",
                        targetKey: "prescription_request_type",
                        newValue: false,
                      },
                    ],
                  },
                  form: {
                    layout_1: {
                      layout: {
                        type: "radioObjectwithImg",
                        label: "Layout",
                        placeholder: "Select Layout",
                        required: false,
                        info: true,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                        options: [
                          {
                            name: "single",
                          },
                          {
                            name: "double",
                          },
                        ],
                      },
                      hr1: {
                        type: "hr",
                        size: "12",
                      },
                      title: {
                        type: "text",
                        label: "Item",
                        placeholder: "Enter Item Name",
                        required: true,
                        info: true,
                        character_count: 250,
                        disabled: false,
                        class: "",
                        size: "6",
                        style: "",
                        displayOnValue: '{"name":"double"}',
                        displayOn: "layout",
                        apply_new_rule: true,
                      },
                      price: {
                        type: "text",
                        label: "Price",
                        placeholder: "Enter Price",
                        required: true,
                        info: true,
                        character_count: 250,
                        disabled: false,
                        class: "",
                        size: "6",
                        style: "",
                        displayOnValue: '{"name":"double"}',
                        displayOn: "layout",
                        apply_new_rule: true,
                      },
                      hr2: {
                        type: "hr",
                        size: "12",
                        displayOnValue: '{"name":"double"}',
                        displayOn: "layout",
                      },
                      description: {
                        type: "ckeditor",
                        label: "Description",
                        placeholder: "Enter Description",
                        required: false,
                        info: false,
                        character_count: 2000,
                        disabled: false,
                        class: "editor-toolbar-bg-change",
                        displayOnValue: '{"name":"single"}',
                        displayOn: "layout",
                        apply_new_rule: true,
                        size: "12",
                        style: "",
                      },
                      hr3: {
                        type: "hr",
                        size: "12",
                        displayOnValue: '{"name":"single"}',
                        displayOn: "layout",
                        apply_new_rule: true,
                      },
                    },
                  },
                  children: [],
                },
              },
            ],
          },
          {
            title: "FAQ",
            service: "categoryFaqs",
            type: "",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: true,
              activeToggle: true,
              deleteButton: true,
              addNewSuccessTitle: "Topic Added!",
              addNewSuccessMessage: "Topic Added Successfully!",
              addNewErrorTitle: "Topic Creation Failed!",
              addNewErrorMessage: "Topic try again!",
              deleteSuccessTitle: "Topic Deleted!",
              deleteSuccessMessage: "Topic Deleted Successfully!",
              deleteErrorTitle: "Topic Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Topic Activated!",
              activeSuccessMessage: "Topic Activated Successfully!",
              activeErrorTitle: "Topic Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Topic Updated!",
              updateSuccessMessage: "Topic Updated Successfully!",
              updateErrorTitle: "Topic Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New FAQ",
                variant: "add",
                form: {
                  title: {
                    type: "text",
                    label: "Question",
                    placeholder: "Enter Question",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProps: {
                  active: true,
                  answer: "",
                  form_layout: "layout_1",
                },
              },
            },
            children: [
              {
                type: "questionsTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "",
                  type: "questionList",
                  info: false,
                  size: "4",
                  style: "",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                },
                form: {
                  title: "Tab Two",
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  submit_url: "/api/pages/$currentPageId",
                  form: {
                    layout_1: {
                      title: {
                        type: "text",
                        label: "Question",
                        placeholder: "Enter Question",
                        required: true,
                        info: true,
                        character_count: 250,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                      },
                      answer: {
                        type: "ckeditor",
                        label: "Answer",
                        placeholder: "Enter Answer",
                        required: true,
                        info: true,
                        character_count: 250,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                      },
                    },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { nonnhsfees };
